

        <!-- preloader start -->
    <div id="pre-load">
        <div id="loader" class="loader">
            <div class="loader-container">
                <div class="loader-icon"><img src="assets/images/favicon-blue.webp" alt=""></div>
            </div>
        </div>
    </div>
    <!-- preloader end -->
    
    <!-- Header area start -->
    <header>
        <div class="rs-header-area rs-header-one">
            <div class="container-fluid g-0">
                <div id="rs-sticky-header" class="header-wrapper rs-sticky-header">
                    <div class="header-left">
                        <div class="header-logo">
                            <a href="/home"><img src="assets/images/logo/logo-white.webp" alt="logo"></a>
                        </div>
                    </div>
                    <div class="header-menu">
                        <nav id="mobile-menu" class="main-menu">
                            <ul class="multipage-menu">
                                <!-- home -->
                                 
                                  <li>                         
                                      <a href="/home">
                                        {{ 'NAV.HOME' | translate }}
                                    </a>
                                   
                                </li>
                                <li>                         
                                      <a href="/about"> {{ 'NAV.ABOUT' | translate }}</a>
                                   
                                </li>
                                  <li>
                                    <a href="/contact"> {{ 'NAV.CONTACT' | translate }}</a>
                                    </li>
<!-- services menu -->
<li class="menu-item-has-children rs-mega-menu">
    <a href="javascript:void(0)">{{ 'NAV.GBETH' | translate }}</a>
    <ul class="mega-menu mega-grid">
          <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.ECT' | translate }}</a>
            <ul>
               <li><a href="/bachloria">{{ 'SUBSUBNAV.CS' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.AI' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.E' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.DS' | translate }}</a></li>
                

            </ul>
        </li>
       
       <li class="rs-menu-item">
           <a href="#" class="title">{{ 'SUBNAV.BEE' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.BF'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.EC' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.A' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.BM'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.ES'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.FL'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.DB'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.FIN'| translate }}</a></li>
            </ul>
        </li>
        <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.FF' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.ME' | translate }}</a></li>
                
            </ul>
        </li>
        <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.HLS' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.BH' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.CH' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.PLS' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MLS' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MHC' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MH' | translate }}</a></li>
            </ul>
        </li>
    </ul>
</li>


                            </ul>
                        </nav>
                    </div>
                    <div class="header-right">
                        <div class="header-icon-wrapper">
                            <!-- search area start -->
                            <div class="header-search-wrapper">
                                <div class="header-search-icon">
                                    <i class="ri-close-fill has-close"></i>
                                    <i class="ri-search-line has-search"></i>
                                </div>
                                <div class="header-search-inner rs-stickys-form" action="#">
                                    <div class="header-search">
                                        <input type="text" placeholder="Searching...">
                                        <button type="submit"><i class="ri-search-line"></i></button>
                                    </div>
                                </div>
                            </div>
                            <!-- search area end -->
                            <!-- hamburger start -->
                            <div class="header-hamburger">
                                    <div class="sidebar-toggle" (click)="toggleOffcanvas()">
        <a class="header-bar-icon" href="javascript:void(0)">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                            <!-- hamburger end -->
                        </div>
                        <!-- button start -->
                        <div class="header-btn">
                            <button type="button"
                                        class="rs-btn has-icon has-theme-yellow hover-white"
                                        (click)="toggleLanguage()">

                                        <span class="language-icon">🌐</span>

                                        <span>
                                            {{ languageService.getLanguage() === 'ar'
                                            ? 'English'
                                            : 'العربية'
                                            }}
                                        </span>
                                        </button>
                           
                        </div>
                        <!-- button end -->
                    </div>
                </div>
            </div>
        </div>
    </header>

    <!-- header area two start-->
    <header>
        <div class="rs-header-area rs-header-one header-transparent  has-space">
            <div class="container-fluid g-0">
                <div class="header-wrapper">
                    <div class="header-left">
                        <div class="header-logo">
                            <a href="/home"><img src="assets/images/logo/logo-white.webp" alt="logo"></a>
                        </div>
                    </div>
                    <div class="header-menu">
                        <nav id="mobile-menu-two" class="main-menu">
                            <ul class="multipage-menu">
                                <!-- home -->
                                 
                                <li>                         
                                      <a href="/home">
                                        {{ 'NAV.HOME' | translate }}
                                      </a>
                                   
                                </li>
                                <li>                         
                                      <a href="/about">{{ 'NAV.ABOUT' | translate }}</a>
                                   
                                </li>
                                
                                <li>
                                    <a href="/contact">{{ 'NAV.CONTACT' | translate }}</a>
                                </li>
                                <!-- services menu -->
<li class="menu-item-has-children rs-mega-menu">
    <a href="javascript:void(0)">{{ 'NAV.GBETH' | translate }}</a>
    <ul class="mega-menu mega-grid">
        <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.ECT' | translate }}</a>
            <ul>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.CS' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.AI' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.E' | translate }}</a></li>
                <li><a href="/bachloria">{{ 'SUBSUBNAV.DS' | translate }}</a></li>
                

            </ul>
        </li>
        <li class="rs-menu-item">
           <a href="#" class="title">{{ 'SUBNAV.BEE' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.BF'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.EC' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.A' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.BM'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.ES'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.FL'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.DB'| translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.FIN'| translate }}</a></li>
            </ul>
        </li>
        <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.FF' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.ME' | translate }}</a></li>
                
            </ul>
        </li>
        <li class="rs-menu-item">
            <a href="#" class="title">{{ 'SUBNAV.HLS' | translate }}</a>
            <ul>
                <li><a href="">{{ 'SUBSUBNAV.BH' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.CH' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.PLS' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MLS' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MHC' | translate }}</a></li>
                <li><a href="">{{ 'SUBSUBNAV.MH' | translate }}</a></li>
            </ul>
        </li>
    </ul>
</li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-right">
                        <div class="header-icon-wrapper">
                            <!-- search area start -->
                            <div class="header-search-wrapper">
                                <div class="header-search-icon">
                                    <i class="ri-close-fill has-close"></i>
                                    <i class="ri-search-line has-search"></i>
                                </div>
                                <div class="header-search-inner rs-stickys-form" action="#">
                                    <div class="header-search">
                                        <input type="text" placeholder="Searching...">
                                        <button type="submit"><i class="ri-search-line"></i></button>
                                    </div>
                                </div>
                            </div>
                            <!-- search area end -->
                            <!-- hamburger start -->
                            <div class="header-hamburger">
                                    <div class="sidebar-toggle" (click)="toggleOffcanvas()">
        <a class="header-bar-icon" href="javascript:void(0)">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </a>
                                </div>
                            </div>
                            <!-- hamburger end -->
                        </div>
                        <!-- button start -->
                        <div class="header-btn">
                            <button
                                        type="button"
                                        class="rs-btn has-icon has-theme-yellow hover-white"
                                        (click)="toggleLanguage()">

                                        <span class="language-icon">🌐</span>

                                        <span>
                                            {{ languageService.getLanguage() === 'ar'
                                            ? 'English'
                                            : 'العربية'
                                            }}
                                        </span>
                                        </button>
                            
                        </div>
                        <!-- button end -->
                    </div>
                </div>
            </div>
        </div>
    </header>
    <!-- header area two end-->
    <!-- Header area end -->
    <!-- Offcanvas area start -->
    <div class="fix">
        <div class="offcanvas-area has-theme-yellow" data-lenis-prevent [class.info-open]="offcanvasOpen()">
            <div class="offcanvas-wrapper">
                <div class="offcanvas-content">
                    <div class="offcanvas-top d-flex justify-content-between align-items-center mb-20">
                        <div class="offcanvas-logo">
                            <a class="logo-black" href="/home"><img src="assets/images/logo/logo-blue.webp" alt="logo"></a>
                        </div>
                        <div class="offcanvas-close">
                            <button class="offcanvas-close-icon animation--flip" 
        type="button" (click)="closeOffcanvas()">
                                <span class="offcanvas-m-lines">
                                <span class="offcanvas-m-line line--1"></span><span
                                    class="offcanvas-m-line line--2"></span><span
                                    class="offcanvas-m-line line--3"></span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="offcanvas-about mb-30 d-none d-xl-block">
                        <p>
                           {{ 'HOME.DESCRIPTION' | translate }}
                        </p>
                    </div>
                    <div class="offcanvas-gallery d-none d-xl-block">
                        <div class="offcanvas-gallery-thumb-wrapper">
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-01.webp">
                                    <img src="assets/images/gallery/gallery-thumb-01.webp" alt="image">
                                </a>
                            </div>
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-02.webp">
                                    <img src="assets/images/gallery/gallery-thumb-02.webp" alt="image">
                                </a>
                            </div>
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-03.webp">
                                    <img src="assets/images/gallery/gallery-thumb-03.webp" alt="image">
                                </a>
                            </div>
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-04.webp">
                                    <img src="assets/images/gallery/gallery-thumb-04.webp" alt="image">
                                </a>
                            </div>
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-05.webp">
                                    <img src="assets/images/gallery/gallery-thumb-05.webp" alt="image">
                                </a>
                            </div>
                            <div class="offcanvas-popup-thumb">
                                <a class="popup-image" href="assets/images/gallery/gallery-thumb-06.webp">
                                    <img src="assets/images/gallery/gallery-thumb-06.webp" alt="image">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="mobile-menu">
                        <div class="rs-offcanvas-menu mb-30">
                            <nav></nav>
                        </div>
                    </div>
                    <div class="offcanvas-contact mb-30">
                        <h4 class="offcanvas-title-meta"> {{ 'NAV.CONTACTInfo' | translate }}</h4>
                        <ul>
                            <li class="d-flex gap-15">
                                <div class="offcanvas-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
                                        <path d="M11.8768 9.68475C11.3059 10.835 10.5331 11.9818 9.74128 13.0109C8.95198 14.0368 8.15999 14.9249 7.5643 15.5572C7.48514 15.6412 7.40956 15.7206 7.33802 15.7951C7.26648 15.7206 7.1909 15.6412 7.11174 15.5572C6.51605 14.9249 5.72406 14.0368 4.93476 13.0109C4.14299 11.9818 3.37019 10.835 2.79925 9.68475C2.22242 8.52266 1.89032 7.43373 1.89032 6.5C1.89032 3.50846 4.32934 1.08333 7.33802 1.08333C10.3467 1.08333 12.7857 3.50846 12.7857 6.5C12.7857 7.43373 12.4536 8.52266 11.8768 9.68475ZM7.33802 17.3333C7.33802 17.3333 13.8753 11.1732 13.8753 6.5C13.8753 2.91015 10.9484 0 7.33802 0C3.7276 0 0.800781 2.91015 0.800781 6.5C0.800781 11.1732 7.33802 17.3333 7.33802 17.3333Z" fill="#6D6D6D"></path>
                                        <path d="M7.33802 8.66667C6.13455 8.66667 5.15894 7.69662 5.15894 6.5C5.15894 5.30338 6.13455 4.33333 7.33802 4.33333C8.54149 4.33333 9.5171 5.30338 9.5171 6.5C9.5171 7.69662 8.54149 8.66667 7.33802 8.66667ZM7.33802 9.75C9.14323 9.75 10.6066 8.29492 10.6066 6.5C10.6066 4.70507 9.14323 3.25 7.33802 3.25C5.53281 3.25 4.0694 4.70507 4.0694 6.5C4.0694 8.29492 5.53281 9.75 7.33802 9.75Z" fill="#6D6D6D"></path>
                                    </svg>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="#"></a>
                                </div>
                            </li>
                            <li class="d-flex gap-15">
                                <div class="offcanvas-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M3.65387 1.32849C3.40343 1.00649 2.92745 0.976861 2.639 1.26531L1.60508 2.29923C1.1216 2.78271 0.94387 3.46766 1.1551 4.06847C2.00338 6.48124 3.39215 8.74671 5.32272 10.6773C7.25329 12.6078 9.51876 13.9966 11.9315 14.8449C12.5323 15.0561 13.2173 14.8784 13.7008 14.3949L14.7347 13.361C15.0231 13.0726 14.9935 12.5966 14.6715 12.3461L12.3653 10.5524C12.2008 10.4245 11.9866 10.3793 11.7845 10.4298L9.59541 10.9771C9.00082 11.1257 8.37183 10.9515 7.93845 10.5181L5.48187 8.06155C5.04849 7.62817 4.87427 6.99919 5.02292 6.40459L5.57019 4.21553C5.62073 4.01336 5.57552 3.79918 5.44758 3.63468L3.65387 1.32849ZM1.88477 0.511076C2.62689 -0.231039 3.8515 -0.154797 4.49583 0.673634L6.28954 2.97983C6.6187 3.40304 6.73502 3.95409 6.60498 4.47423L6.05772 6.66329C5.99994 6.8944 6.06766 7.13888 6.2361 7.30732L8.69268 9.7639C8.86113 9.93235 9.1056 10.0001 9.33671 9.94229L11.5258 9.39502C12.0459 9.26499 12.597 9.3813 13.0202 9.71047L15.3264 11.5042C16.1548 12.1485 16.231 13.3731 15.4889 14.1152L14.455 15.1492C13.7153 15.8889 12.6089 16.2137 11.5778 15.8512C9.01754 14.9511 6.61438 13.4774 4.56849 11.4315C2.5226 9.38562 1.04895 6.98246 0.148838 4.42225C-0.213682 3.39112 0.11113 2.28472 0.85085 1.545L1.88477 0.511076Z" fill="#6D6D6D"></path>
                                        <path d="M11 0.5C11 0.223858 11.2239 0 11.5 0H15.5C15.7761 0 16 0.223858 16 0.5V4.5C16 4.77614 15.7761 5 15.5 5C15.2239 5 15 4.77614 15 4.5V1.70711L10.8536 5.85355C10.6583 6.04882 10.3417 6.04882 10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645L14.2929 1H11.5C11.2239 1 11 0.776142 11 0.5Z" fill="#6D6D6D"></path>
                                    </svg>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="tel:+12346691234"> ⁦+33 6 10 12 36 57⁩ </a>
                                </div>
                            </li>
                            <li class="d-flex gap-15">
                                <div class="offcanvas-contact-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M2 2C0.895431 2 0 2.89543 0 4V12L2.58386e-05 12.0103C0.00555998 13.1101 0.898859 14 2 14H7.5C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13H2C1.53715 13 1.14774 12.6855 1.03376 12.2586L6.67417 8.7876L8 9.5831L15 5.3831V8.5C15 8.77614 15.2239 9 15.5 9C15.7761 9 16 8.77614 16 8.5V4C16 2.89543 15.1046 2 14 2H2ZM5.70808 8.20794L1 11.1052V5.3831L5.70808 8.20794ZM1 4.2169V4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V4.2169L8 8.4169L1 4.2169Z" fill="#6D6D6D"></path>
                                        <path d="M14.2467 14.2686C15.2567 14.2686 15.8339 13.4116 15.8339 12.2442V12.0344C15.8339 10.4297 14.6402 9 12.5197 9H12.4847C10.421 9 9 10.3598 9 12.4322V12.6465C9 14.8195 10.4385 16 12.3579 16H12.4016C12.9963 16 13.4204 15.9257 13.639 15.8251V15.0949C13.3941 15.2042 12.9656 15.2742 12.4585 15.2742H12.4147C11.0812 15.2742 9.84385 14.4872 9.84385 12.6202V12.4628C9.84385 10.8057 10.9019 9.73891 12.4847 9.73891H12.524C14.0587 9.73891 15.0075 10.7883 15.0075 12.065V12.183C15.0075 13.158 14.6839 13.5734 14.3691 13.5734C14.1374 13.5734 13.9582 13.4247 13.9582 13.1537V10.9631H13.0531V11.5315H13.0225C12.9394 11.2342 12.6552 10.9019 12.0693 10.9019C11.2911 10.9019 10.8101 11.4572 10.8101 12.3011V12.8301C10.8101 13.722 11.2998 14.2642 12.0693 14.2642C12.5415 14.2642 12.9656 14.0369 13.0837 13.6215H13.1274C13.2455 14.0412 13.7439 14.2686 14.2467 14.2686ZM11.7939 12.6814V12.4541C11.7939 11.9076 12.0212 11.6627 12.3666 11.6627C12.664 11.6627 12.9394 11.8551 12.9394 12.371V12.7383C12.9394 13.3111 12.6858 13.4816 12.3754 13.4816C12.0212 13.4816 11.7939 13.2673 11.7939 12.6814Z" fill="#6D6D6D"></path>
                                    </svg>
                                </div>
                                <div class="offcanvas-contact-text">
                                    <a href="mailto:gbet.fr@gmail.com">gbet.fr@gmail.com</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="offcanvas-social">
                        <h4 class="offcanvas-title-meta">{{ 'NAV.FOLLOWUS' | translate }}</h4>
                        <ul>
                            <li><a href="#"><i class="ri-facebook-fill"></i></a></li>
                            <li><a href="#"><i class="ri-twitter-x-fill"></i></a></li>
                            <li><a href="#"><i class="ri-youtube-fill"></i></a></li>
                            <li><a href="#"><i class="ri-linkedin-box-fill"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
  <div class="offcanvas-overlay" 
     [class.overlay-open]="offcanvasOpen()"
     (click)="closeOffcanvas()"></div>
<div class="offcanvas-overlay-white"
     [class.overlay-open]="offcanvasOpen()"
     (click)="closeOffcanvas()"></div>
    <!-- Offcanvas area start -->
<!-- Body main wrapper start -->



     <main>
        <!-- banner area start -->

                
        
<router-outlet></router-outlet>
</main>



    <!-- footer area start -->
    <footer class="rs-footer-area rs-footer-one">
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="rs-footer-wrapper">
                        <div class="rs-footer-left">
                            <div class="rs-footer-widget footer-1-col-1">
                                <div class="rs-footer-widget-logo">
                                    <a href="/home"><img src="assets/images/logo/logo-white.webp" alt="logo"></a>
                                </div>
                                <div class="rs-footer-widget-content">
                                    <div class="rs-footer-widget-contact-info">
                                        <div class="rs-footer-content-item">
                                            <span>Phone:</span>
                                            <a href="tel:+990123456789">⁦+33 6 10 12 36 57⁩</a>
                                        </div>
                                        <div class="rs-footer-content-item">
                                            <span>Email:</span>
                                            <a href="mailto:gbet.fr@gmail.com">gbet.fr@gmail.com</a>
                                        </div>
                                    </div>
                                    <div class="rs-footer-app-badges">
                                        <a href="#">
                                            <img src="assets/images/icon/icon-02.webp" alt="Google Play">
                                        </a>
                                        <a href="#">
                                            <img src="assets/images/icon/icon-03.webp" alt="App Store">
                                        </a>
                                    </div>
                                    <div class="rs-footer-widget-social">
                                        <span class="rs-footer-social-title">{{ 'NAV.SOCIALLINK' | translate }}</span>
                                        <div class="rs-footer-social theme-social has-radius-none has-medium hover-yellow has-theme-blue">
                                            <a href="#"><svg width="14" height="22" viewBox="0 0 14 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.624 11.9541L12.193 8.54137L8.63572 8.54137V6.32676C8.63572 5.39311 9.13264 4.48303 10.7258 4.48303H12.343V1.57748C12.343 1.57748 10.8755 1.34692 9.47233 1.34692C6.54282 1.34692 4.62796 2.98146 4.62796 5.94041L4.62796 8.54137H1.37158L1.37158 11.9541H4.62796L4.62796 20.2041H8.63572L8.63572 11.9541H11.624Z" fill="white"></path>
                                                </svg></a>
                                            <a href="#"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.6045 5.45036C17.5641 4.53485 17.4161 3.9055 17.204 3.3601C16.9852 2.78121 16.6486 2.26294 16.2077 1.83208C15.7768 1.39452 15.2551 1.0545 14.6829 0.839154C14.1344 0.627106 13.5083 0.479009 12.5928 0.438686C11.6705 0.394863 11.3777 0.384766 9.03843 0.384766C6.69917 0.384766 6.40637 0.394863 5.48747 0.435253C4.57199 0.475643 3.94261 0.623808 3.39738 0.835721C2.81832 1.0545 2.30005 1.39108 1.86919 1.83208C1.43163 2.26291 1.09178 2.78461 0.876264 3.3568C0.664216 3.9055 0.516152 4.53148 0.475796 5.44692C0.432006 6.36927 0.421875 6.66206 0.421875 9.00132C0.421875 11.3406 0.432006 11.6334 0.472363 12.5523C0.512753 13.4678 0.660917 14.0971 0.872999 14.6425C1.09178 15.2214 1.43163 15.7397 1.86919 16.1706C2.30005 16.6081 2.82175 16.9481 3.39395 17.1635C3.94258 17.3755 4.56856 17.5236 5.4842 17.564C6.40294 17.6045 6.6959 17.6144 9.03516 17.6144C11.3744 17.6144 11.6672 17.6045 12.5861 17.564C13.5016 17.5236 14.131 17.3756 14.6762 17.1635C15.2489 16.9421 15.7689 16.6035 16.2031 16.1693C16.6372 15.7352 16.9759 15.2152 17.1973 14.6425C17.4092 14.0939 17.5574 13.4678 17.5978 12.5523C17.6382 11.6334 17.6483 11.3406 17.6483 9.00132C17.6483 6.66206 17.6449 6.36923 17.6045 5.45036ZM16.0529 12.485C16.0159 13.3264 15.8745 13.7808 15.7567 14.0837C15.4672 14.8343 14.8715 15.4301 14.1208 15.7196C13.8179 15.8374 13.3603 15.9787 12.5221 16.0157C11.6133 16.0562 11.3408 16.0662 9.04186 16.0662C6.74296 16.0662 6.46699 16.0562 5.56148 16.0157C4.72002 15.9787 4.26563 15.8374 3.96271 15.7196C3.5892 15.5815 3.24922 15.3628 2.97322 15.0767C2.68712 14.7973 2.46834 14.4607 2.33027 14.0872C2.21247 13.7842 2.07114 13.3264 2.03421 12.4884C1.99369 11.5796 1.98373 11.3069 1.98373 9.00802C1.98373 6.70911 1.99369 6.43315 2.03421 5.5278C2.07114 4.68634 2.21247 4.23196 2.33027 3.92903C2.46834 3.55535 2.68712 3.21544 2.97665 2.93937C3.25588 2.65328 3.59246 2.4345 3.96614 2.2966C4.26907 2.17879 4.72689 2.03743 5.56491 2.00037C6.47369 1.95998 6.74639 1.94988 9.04513 1.94988C11.3475 1.94988 11.62 1.95998 12.5255 2.00037C13.367 2.03746 13.8214 2.17876 14.1243 2.29656C14.4978 2.4345 14.8378 2.65328 15.1138 2.93937C15.3999 3.21877 15.6186 3.55535 15.7567 3.92903C15.8745 4.23196 16.0159 4.68961 16.0529 5.5278C16.0933 6.43658 16.1034 6.70911 16.1034 9.00802C16.1034 11.3069 16.0933 11.5762 16.0529 12.485Z" fill="white"></path>
                                                    <path d="M9.0335 4.57741C6.58997 4.57741 4.60742 6.55982 4.60742 9.00349C4.60742 11.4472 6.58997 13.4296 9.0335 13.4296C11.4771 13.4296 13.4596 11.4472 13.4596 9.00349C13.4596 6.55982 11.4771 4.57741 9.0335 4.57741ZM9.0335 11.8746C7.44826 11.8746 6.16237 10.5889 6.16237 9.00349C6.16237 7.41811 7.44826 6.13243 9.03347 6.13243C10.6188 6.13243 11.9046 7.41811 11.9046 9.00349C11.9046 10.5889 10.6188 11.8746 9.0335 11.8746ZM14.668 4.40239C14.668 4.97303 14.2053 5.4357 13.6345 5.4357C13.0639 5.4357 12.6013 4.97303 12.6013 4.40239C12.6013 3.83167 13.0639 3.36914 13.6346 3.36914C14.2053 3.36914 14.668 3.83164 14.668 4.40239Z" fill="white"></path>
                                                </svg></a>
                                            <a href="#"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.35332 6.88729L14.6472 0.733521H13.3928L8.79603 6.07675L5.12465 0.733521H0.890137L6.44199 8.81343L0.890137 15.2666H2.1447L6.99896 9.62397L10.8762 15.2666H15.1107L9.35332 6.88729ZM7.63502 8.88462L7.0725 8.08004L2.59674 1.67793H4.52367L8.13567 6.84464L8.69818 7.64922L13.3933 14.3651H11.4664L7.63502 8.88462Z" fill="white"></path>
                                                </svg></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="rs-footer-right">
                            <div class="rs-footer-widget-wrapper">
                                <div class="rs-footer-widget footer-1-col-2">
                                    <h5 class="rs-footer-widget-title">{{ 'NAV.CAMPUS' | translate }}​</h5>
                                    <div class="rs-footer-widget-link has-theme-yellow">
                                        <ul>
                                            <li><a href="/about">{{ 'NAV.ABOUTGBET' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.AlumniNetwork' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.GbetLibrary' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.CampusLife' | translate }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="rs-footer-widget footer-1-col-3">
                                    <h5 class="rs-footer-widget-title">{{ 'NAV.UsefulLinks' | translate }}</h5>
                                    <div class="rs-footer-widget-link has-theme-yellow">
                                        <ul>
                                            <li><a href="">{{ 'NAV.FacultyAreas' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.GraduatePrograms' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.CampusEvents' | translate }}</a></li>
                                            <li><a href="">{{ 'NAV.HowtoApply' | translate }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="rs-footer-widget footer-1-col-4">
                                    <h5 class="rs-footer-widget-title">{{ 'NAV.Newsletter' | translate }}</h5>
                                    <div class="rs-cta-input">
                                        <input id="email2" name="name" type="text" placeholder="Enter your email">
                                        <button type="submit" class="rs-square-btn has-icon has-transparent is-white">
                                            <span class="icon-box">
                                 <svg class="icon-first" width="16" height="16" viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                       d="M12.0743 8.70831L0.916528 8.70831L0.916528 6.87526L12.0737 6.87461L7.15722 1.95816L8.45358 0.661793L15.5836 7.79179L8.45358 14.9218L7.15722 13.6254L12.0743 8.70831Z"
                                       fill="white"></path>
                                 </svg>

                                 <svg class="icon-second" width="16" height="16" viewBox="0 0 16 16"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                       d="M12.0743 8.70831L0.916528 8.70831L0.916528 6.87526L12.0737 6.87461L7.15722 1.95816L8.45358 0.661793L15.5836 7.79179L8.45358 14.9218L7.15722 13.6254L12.0743 8.70831Z"
                                       fill="white"></path>
                                 </svg>
                              </span>
                                        </button>
                                        <div class="rs-form-check">
                                            <input id="remeber" type="checkbox">
                                            <label for="remeber">{{ 'NAV.ACCEPT' | translate }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rs-footer-copyright-area rs-copyright-one">
                                <div class="rs-footer-copyright-wrapper">
                                    <div class="rs-footer-copyright-right">
                                        <div class="rs-footer-copyright-item">
                                            <div class="rs-footer-copyright">
                                                <p class="underline">Copyright © <span id="year">2026</span> Gbet Group.
                                                    Developed by <a target="_blank" href="https://Mastersoft-co.com">Mastersoft Co.</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rs-footer-copyright-left">
                                        <div class="rs-footer-copyright-item">
                                            <div class="rs-footer-copyright-link">
                                                <a href="">{{ 'NAV.TA' | translate }}</a>
                                            </div>
                                        </div>
                                        <div class="rs-footer-copyright-item">
                                            <div class="rs-footer-copyright-link">
                                                <a href="">{{ 'NAV.Privacypolicy' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    <!-- footer area end -->

    <!-- backto top start -->
    <div id="backtotop-wrap">
        <svg class="arrowicon" viewBox="0 0 24 24" width="18" height="18">
            <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#000">
            </path>
        </svg>
        <svg class="scrollprogress" width="40" height="40">
            <circle class="progress-circle" cx="20" cy="20" r="18" stroke-width="2" fill="none" stroke="#fff" stroke-dasharray="113.1" stroke-dashoffset="113.1"></circle>
        </svg>
    </div>
    <!-- backto top end -->


